import './signUpBackground.css';

export default function SignUpBackground() {
    return (
        <div className="sign-up-background">
            <svg width="1006.555" height="1113.046" viewBox="0 0 1006.555 1113.046">
        <defs>
            <clipPath id="clip-path">
            <rect id="Rectangle_945" data-name="Rectangle 945" width="1006.555" height="1094.046" fill="none"/>
            </clipPath>
        </defs>
        <g id="Group_699" data-name="Group 699" transform="translate(-58.445 -212.954)">
            <circle id="Ellipse_47" data-name="Ellipse 47" cx="91.5" cy="91.5" r="91.5" transform="translate(93 448)" fill="#77b6db"/>
            <circle id="Ellipse_46" data-name="Ellipse 46" cx="91.5" cy="91.5" r="91.5" transform="translate(711 1143)" fill="#77b6db"/>
            <g id="Group_493" data-name="Group 493" transform="translate(58.445 212.954)">
            <g id="Group_492" data-name="Group 492" clip-path="">
                <path id="Path_367" data-name="Path 367" d="M976.312,912.777a71.959,71.959,0,0,1-43.881,13.454c-1.12,3.126-2.4,6.218-3.82,9.242a100.559,100.559,0,1,1-172.085,103h-506.4A94.856,94.856,0,0,1,84.9,946.575,72.306,72.306,0,0,1,128.982,840.06V340.429c-1.714.257-3.439.493-5.176.683A111.63,111.63,0,0,1,46.653,139.384,100.554,100.554,0,0,1,207.647,49.057H681.176A100.573,100.573,0,0,1,845.027,36.443a111.65,111.65,0,0,1,57.179,214.981c.011.57.022,1.13.022,1.7a72.309,72.309,0,0,1-48.81,68.383V779.553a111.58,111.58,0,0,1,37.44,16.637c.448-.347.907-.683,1.367-1.008a72.283,72.283,0,0,1,84.088,117.6" transform="translate(0)" fill="#88cdf6"/>
            </g>
            </g>
        </g>
        </svg>
        </div>
    )
}